/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.get.to.know.me.data.rpc.UtilsRpc
 */

export const getDomainRpc = {
  serviceName: 'com.hubspot.get.to.know.me.data.rpc.UtilsRpc',
  rpcName: 'getDomain',
  auth: 'external',
  fingerprint: 'YPn4rv-edC-n-SMrdfHVzes2Yuo4np1m',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAvailableIndustriesRpc = {
  serviceName: 'com.hubspot.get.to.know.me.data.rpc.UtilsRpc',
  rpcName: 'getAvailableIndustries',
  auth: 'external',
  fingerprint: 'NKbpzuWSgN0znVl0w24baOs2Yuo4np1m',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};